import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import Select from "react-select";
const AllDeptStock = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [department, setDepartment] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const today = new Date().toISOString().split('T')[0];
  const [inputs, setInputs] = useState({
    start_date: today,
    end_date: today,
  });

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const me = await Http.get(`/me`);
      setMe(me?.data?.data);
      console.log(me?.data.data, "data");

      // Only call the API if the user is not an admin
      // if (me.data.data.user_type !== "admin") {
        // const res = await Http.get(`/all-product-stock`);
        // setReceiveData(res.data.info);
      // }

      const resRole = await Http.get(`/staff-type-check`);
      setRole(resRole.data);

      const resDepartment = await Http.get("/departmentArtSelect2");
      setDepartment(resDepartment.data);


      const submissionData = {
        department_art_id: 1,
        data: {
          ...inputs,
          end_date: inputs.start_date // Set end_date to the value of start_date
        }
      };

      const response = await Http.post("/deparment-wise-product-stock", submissionData);
      // showAlert("Department submitted successfully!", "success");
      // console.log(response.data); // Handle the response as needed
      setReceiveData(response?.data);

      if (resDepartment.data && resDepartment.data.length > 0) {
        const firstDepartment = resDepartment.data[0];
        setSelectedStore(firstDepartment);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // Ensure the selected date falls within the current month range
    setInputs((prev) => ({ ...prev, [name]: value }));
  };


  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };
  console.log(me, "me");

  function formatType(value) {
    if (!value) return ""; // Handle empty or undefined values
    return value
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Join the words back with spaces
  }

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "shape_name", header: "Shape Name" },
    ...(selectedStore?.value === 7
      ? [
          {
            field: (rowData) => (parseFloat(rowData.glaze_name) || 0).toFixed(2),
            header: "Glaze Name",
          },
        ]
      : []),
      ...(selectedStore?.value === 11 || selectedStore?.value === 12 || selectedStore?.value === 13 || selectedStore?.value === 33
      ? [
          {
            field: (rowData) => (parseFloat(rowData.decoration_code) || 0).toFixed(2),
            header: "Decoration Code",
          },
          {
            field: (rowData) => (parseFloat(rowData.decoration_name) || 0).toFixed(2),
            header: "Decoration Name",
          },
        ]
      : []),
    {
      field: (rowData) => {
        const stockQty = parseFloat(rowData.stockQty) || 0;
        if (selectedStore?.value === 2 || selectedStore?.value === 3) {
          return rowData?.id === 1
            ? (stockQty * 20).toFixed(2)
            : stockQty.toFixed(2);
        } else if (selectedStore?.value === 1) {
          return stockQty.toFixed(2);
        } else {
          return stockQty.toFixed(2);
        }
      },
      header: "Stock",
    },
    ...(selectedStore?.value === 11 || selectedStore?.value === 8
      ? [
          {
            field: (rowData) => (parseFloat(rowData.stockQtyExportClass) || 0).toFixed(2),
            header: "Qty Export",
          },
          {
            field: (rowData) => (parseFloat(rowData.stockQtyAClass) || 0).toFixed(2),
            header: "Qty A Class",
          },
          {
            field: (rowData) => (parseFloat(rowData.stockQtyBClass) || 0).toFixed(2),
            header: "Qty B Class",
          },
          {
            field: (rowData) => (parseFloat(rowData.stockQtyCClass) || 0).toFixed(2),
            header: "Qty C Class",
          },
        ]
      : []),
    ...(selectedStore?.value === 9 || selectedStore?.value === 12
      ? [
          {
            field: (rowData) => (parseFloat(rowData.stockQtyAClass) || 0).toFixed(2),
            header: "Qty A Class",
          },
          {
            field: (rowData) => (parseFloat(rowData.stockQtyBClass) || 0).toFixed(2),
            header: "Qty B Class",
          },
          {
            field: (rowData) => (parseFloat(rowData.stockQtyCClass) || 0).toFixed(2),
            header: "Qty C Class",
          },
        ]
      : []),
    ...(selectedStore?.value === 10 || selectedStore?.value === 13
      ? [
          {
            field: (rowData) => (parseFloat(rowData.stockQtyExportClass) || 0).toFixed(2),
            header: "Qty Export",
          },
        ]
      : []),
  ];

  console.log(receiveData, "receiveData");

  // const handleStoreChange = (event) => {
  //   setSelectedStore(parseInt(event.target.value));
  //   // You can also handle any additional logic based on the selected store here
  // };

  const handleSubmit = async (store) => {
    const targetStore = store || selectedStore;
    if (!targetStore) {
      showAlert("Please select a department.", "error");
      return;
    }
    setLoading(true); // Start loading

    try {
      // Prepare data for submission
      const submissionData = {
        department_art_id: targetStore.value,
        data: {
          ...inputs,
          end_date: inputs.start_date // Set end_date to the value of start_date
        }
      };

      console.log(targetStore, "submissionData");

      const response = await Http.post("/deparment-wise-product-stock", submissionData);
      // showAlert("Department submitted successfully!", "success");
      console.log(response.data); // Handle the response as needed
      setReceiveData(response?.data);
      setLoading(false); // Stop loadings
    } catch (error) {
      console.error("Submission error:", error);
      showAlert("Error submitting department.", "error");
      setLoading(false);
    }
  };


  const selectHandleChanges = (selectedOption) => {
    setSelectedStore(selectedOption);
    handleSubmit(selectedOption);
  };
  return (
    <div>
      <IsLogin></IsLogin>
      {/* Dropdown for store selection */}

      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            {/* if role is admin then h5 tag is "Store Stocks" else the following one */}
            {/* {role === "admin" ? ( */}
              <h5 className="am-title">All deparment stock</h5>
            {/* ) : (
              <h5 className="am-title">Stock Without Breakdown</h5>
            )} */}
            {/* <h5 className="am-title">Stock Without Breakdown</h5> */}
            {/* <Link to="/create-damage-return" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New Damage Return
              </Link> */}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />
            {/* {role === "admin" && ( */}
              <div className="card">
                <div className="row">
                  <div className="col-lg-4">
                    <label>
                      Department <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={selectedStore} // Instead of defaultValue={department[0]}
                      name="department_art_id"
                      options={department}
                      onChange={selectHandleChanges}
                    />
                  </div>
                  {/* <div className="col-lg-4">
                    <label htmlFor="">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={inputs.start_date}
                      onChange={handleChange}
                    />
                  </div> */}
                  {/* <div className="col-lg-4">
                    <label htmlFor="">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={inputs.end_date}
                      onChange={handleChange}
                    />
                  </div> */}
                </div>
              </div>
            {/* )} */}

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllDeptStock;
